import { render, staticRenderFns } from "./DonorDetail.vue?vue&type=template&id=b8272050&scoped=true&"
import script from "./DonorDetail.vue?vue&type=script&lang=js&"
export * from "./DonorDetail.vue?vue&type=script&lang=js&"
import style0 from "./DonorDetail.vue?vue&type=style&index=0&id=b8272050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8272050",
  null
  
)

export default component.exports